import { observable, action, runInAction } from 'mobx';
import { RootStore } from './RootStore';
import request from '../utils/request';

// 存储区
export default class ChatStore {
  rootStore: RootStore;
  @observable roomId: string;
  @observable userId: string;
  @observable messageList: any[];
  @observable input: string;
  @observable uploadInfo: any;


  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.roomId = this.getRoomId();
    this.userId = '';
    this.messageList = [];
    this.input = '';
  }

  @action
  getRoomId() {
    if (localStorage.getItem('roomId') == null) {
      this.roomId = String(Math.floor(100000 + Math.random() * 900000));
      localStorage.setItem('roomId', this.roomId);
    } else {
      this.roomId = localStorage.getItem('roomId') as string;
    }
    return this.roomId;
  }

  @action
  async get(store: ChatStore) {
    const response = await getRequest(store.roomId);
    if (response == undefined)
      return;
    runInAction(() => {
      if (response.status == 200) {
        store.userId = response.json.message.userId
        store.messageList = response.json.message.messageList
      }
    })
  }

  @action
  async send() {
    const response = await sendRequest(this.roomId, this.input, { 'msgType': 'text', 'text': this.input });
    if (response == undefined)
      return;
    runInAction(() => {
      if (response.status == 200) {
        if (this.messageList.length == 10) {
          this.messageList.shift()
        }
        this.messageList.push(response.json.message)
      }
    })
  }

  @action
  async getFileUrl(fileName: string) {
    const response = await getFileUrlRequest(fileName)
    if (response == undefined)
      return;
    runInAction(() => {
      if (response.status == 200) {
        this.uploadInfo = response.json.message
      }
    })
  }

}

//请求区
export async function getRequest(roomId: string) {
  return request('/api/chat/get?roomId=' + roomId, {
    method: 'GET',
  })
}

export async function sendRequest(roomId: string, text: string, body: any) {
  return request('/api/chat/send?roomId=' + roomId, {
    method: 'POST',
    body: body,
  })
}

export async function getFileUrlRequest(fileName: string) {
  return request('/api/chat/getFileUrl?fileName=' + fileName, {
    method: 'GET',
  })
}

